import { render, staticRenderFns } from "./PaperPlaneOutline.vue?vue&type=template&id=34a15f92&"
import script from "./PaperPlaneOutline.vue?vue&type=script&lang=ts&"
export * from "./PaperPlaneOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports